import { Result, Spin, Button, Space, message } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import Modal from "../../generic/Modal";
import { useMediaHandler } from "../../../hooks/useMediaHandler";

const HtmlViewer = ({ url = "", onClose, onError }) => {
  const [html, setHtml] = useState("");
  const { handleError, isLoading, handleLoaded } = useMediaHandler({
    src: url,
    onError,
  });
  const [isError, setIsError] = useState(false);
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!url) return;

    const fetchHtml = async () => {
      try {
        setIsError(false);

        const res = await axios.get(url, {
          responseType: "text",
        });

        const contentType = res.headers["content-type"];

        if (!contentType?.includes("text/html")) {
          throw new Error("Not HTML");
        }

        setHtml(res.data);
        handleLoaded();
      } catch (err) {
        console.error("Preview failed:", err);
        setIsError(true);
        handleError();
      }
    };

    fetchHtml();
  }, [url]);

  return (
    <Modal
      open
      style={{
        top: "8px",
        padding: 0,
        height: "calc(100dvh - 16px)",
      }}
      width={"100dvw"}
      styles={{
        container: {
          height: "calc(100dvh - 16px)",
          overflow: "auto",
          padding: 0,
        },
        body: {
          height: "calc(100% - 55px)",
          padding: "0px 20px 20px 20px",
        },
      }}
      title={
        !isLoading &&
        !isError && (
          <Space style={{ padding: "10px 20px 2px 20px" }}>
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={() => {
                if (iframeRef.current) {
                  try {
                    iframeRef.current.contentWindow.print();
                  } catch (err) {
                    console.error("Print failed:", err);
                    message.error("Print failed. Please try again.");
                  }
                }
              }}
            >
              Print
            </Button>
          </Space>
        )
      }
      footer={null}
      onCancel={onClose}
    >
      {isLoading && (
        <div className="flex-center h-100 w-100">
          <Spin size="large" />
        </div>
      )}

      {!isLoading && !isError && (
        <iframe
          ref={iframeRef}
          title="HTML Viewer"
          srcDoc={html}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
          onLoad={(e) => {
            //@ts-ignore
            const doc = e.target.contentDocument;
            if (doc) {
              const style = doc.createElement("style");
              style.textContent = `
                a { cursor: default !important; pointer-events: none !important; }
              `;
              doc.head.appendChild(style);
            }
          }}
        />
      )}

      {!isLoading && isError && (
        <div className="flex-center h-100 w-100">
          <Result
            status="warning"
            title="Preview not available"
            subTitle="This file cannot be previewed."
          />
        </div>
      )}
    </Modal>
  );
};

export default HtmlViewer;
